import { render, staticRenderFns } from "./NavClient.vue?vue&type=template&id=b71f7bd8&"
import script from "./NavClient.vue?vue&type=script&lang=js&"
export * from "./NavClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports